"use strict";import{IconCross500 as o}from"../src/elements/IconCross500.js";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";e("sp-icon-cross500",o);
//# sourceMappingURL=sp-icon-cross500.js.map
